const AzureConstant = {
    LOCAL_APP: 'https://localhost:44321/',
    DEV_APP: 'app-nbaofficials-dev-001.azurewebsites.net',
    QA_APP: 'app-nbaofficials-qa-001.azurewebsites.net',
    PROD_02_APP: 'app-nbaofficials-prod-002.azurewebsites.net',
    PROD_APP: 'nbaofficials.com',
    TENANT_ID: 'e898ff4a-4b69-45ee-a3ae-1cd6f239feb2',
    DEV_CLIENT: '60c199f9-602e-4b0e-8248-fd0c0defc5ee',
    QA_CLIENT: 'a9d33c14-360e-442a-979c-a2e65f47dddf',
    PROD_02_CLIENT: '8c529bf0-d126-4647-841c-e2cd23879609',
    PROD_CLIENT: '8c529bf0-d126-4647-841c-e2cd23879609',

};

export default AzureConstant;